import { createIcon } from '@chakra-ui/react';

export const MerchantBoldIcon = createIcon({
  displayName: 'MerchantBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M3.18066 4.72021H12.8271C13.1409 4.72021 13.4712 4.72903 13.7275 4.87061C13.842 4.93392 13.9434 5.02582 14.0205 5.17236C14.1001 5.32377 14.167 5.55941 14.167 5.92627C14.167 6.43 14.0698 6.69673 13.9717 6.83936C13.8825 6.96892 13.7577 7.04636 13.5654 7.09229C13.4279 7.12075 13.2756 7.1333 13.0938 7.1333H2.90723C2.71176 7.1333 2.55618 7.12591 2.4248 7.09424L2.41699 7.09229L2.32031 7.06494C2.23135 7.03412 2.16397 6.99183 2.1084 6.93408V6.93311L2.10059 6.92627C1.95717 6.78274 1.83398 6.51616 1.83398 5.92627C1.83402 5.55939 1.90087 5.32368 1.98047 5.17236C2.05751 5.02598 2.15865 4.93397 2.27344 4.87061C2.5307 4.72867 2.86316 4.72021 3.18066 4.72021Z"
          fill="#391CAD"
          stroke="#391CAD"
        />
        <path
          d="M3.24707 9H12.7002C12.792 9 12.8634 9.07089 12.8662 9.15918L12.8633 9.19824L12.1895 12.6855V12.6865C12.0701 13.3131 11.9279 13.7796 11.624 14.1045C11.3404 14.4074 10.8349 14.667 9.79395 14.667H6.05371C5.05055 14.667 4.51971 14.3734 4.20996 14.0293C3.88218 13.665 3.72947 13.1656 3.64062 12.6201V12.6191L3.08008 9.19238C3.06382 9.09272 3.13961 9.00001 3.24707 9ZM6.61328 9.63379C6.07287 9.63405 5.64767 10.0751 5.64746 10.5996V12.7998C5.64746 13.3358 6.07736 13.7663 6.61328 13.7666C7.14743 13.7666 7.57422 13.3312 7.57422 12.7998V10.5996C7.57402 10.112 7.20317 9.68943 6.71289 9.63867L6.61328 9.63379ZM9.45996 9.63379C8.93083 9.63405 8.49436 10.0705 8.49414 10.5996V12.7998C8.49414 13.3404 8.93535 13.7663 9.45996 13.7666C9.9961 13.7666 10.4268 13.3359 10.4268 12.7998V10.5996C10.4266 10.1078 10.0527 9.6892 9.56055 9.63867L9.45996 9.63379Z"
          fill="#391CAD"
          stroke="#391CAD"
        />
      </svg>
    </>
  ),
});
